import React, { useEffect, useState } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import '../styles/Contactus.css';

const Contactus = () => {

  useEffect(() => {
    document.title = "Contact Us | Inypeople";
  }, []);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    work_email: "",
    company_name: "",
    location: "",
    requirements: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const API = process.env.REACT_APP_API_URL;
const res = await fetch(`${API}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      alert(data.message);

      setFormData({
        first_name: "",
        last_name: "",
        phone_number: "",
        work_email: "",
        company_name: "",
        location: "",
        requirements: ""
      });

    } catch (error) {
      console.log(error);
      alert("Error submitting form");
    }
  };

  return (
    <main className="contactus-main-wrapper">
      {/* Section 1: Form & Steps */}
      <section className="contactus-section contactus-section-formsteps">
        <div className="contactus-content-row">

          {/* Left: Form */}
          <div className="contactus-form-col">
            <div className="contactus-form-card">
              <div className="contactus-form-title">Let’s Talk - Your Free Consultation Awaits</div>

              <form onSubmit={handleSubmit}>

                <div className="contactus-form-row">
                  <input
                    type="text"
                    name="first_name"
                    className="contactus-input"
                    placeholder="First Name*"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="text"
                    name="last_name"
                    className="contactus-input"
                    placeholder="Last Name*"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contactus-form-row">
                  <input
                    type="tel"
                    name="phone_number"
                    className="contactus-input"
                    placeholder="Phone Number*"
                    value={formData.phone_number}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="email"
                    name="work_email"
                    className="contactus-input"
                    placeholder="Work Email*"
                    value={formData.work_email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contactus-form-row">
                  <input
                    type="text"
                    name="company_name"
                    className="contactus-input"
                    placeholder="Company Name*"
                    value={formData.company_name}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="text"
                    name="location"
                    className="contactus-input"
                    placeholder="Location*"
                    value={formData.location}
                    onChange={handleChange}
                    required
                  />
                </div>

                <textarea
                  name="requirements"
                  className="contactus-input contactus-textarea"
                  placeholder="Please enter your requirements*"
                  value={formData.requirements}
                  onChange={handleChange}
                  required
                ></textarea>

                <button type="submit" className="contactus-submit-btn">
                  Submit
                </button>

              </form>
            </div>
          </div>

          {/* Right: What happens next */}
          <div className="contactus-next-col">
            <div className="contactus-next-title">What Happens Next Shapes Trust?</div>

            <div className="contactus-next-step">
              <div className="contactus-step-circle">1</div>
              <div className="contactus-step-text">We listen first and understand your needs.</div>
            </div>

            <div className="contactus-next-step">
              <div className="contactus-step-circle">2</div>
              <div className="contactus-step-text">A quick follow-up call is scheduled at your convenience.</div>
            </div>

            <div className="contactus-next-step">
              <div className="contactus-step-circle">3</div>
              <div className="contactus-step-text">Your concept stays protected with a strict NDA.</div>
            </div>

          </div>

        </div>
      </section>

      <section className="contact-info-section">
        <div className="contact-info-container">

          {/* Left Content */}
          <div className="contact-info-left">
            <h2 className="contact-info-title">Get in touch</h2>

            <div className="contact-block">
              <h3 className="company-title">
                <img src="/assets/icons/Tracking.png" alt="Company Icon" className="company-icon"/>
                Inypeople Technology Private Limited
              </h3>

              <p>
                No 2, First Floor, Avvaiyar Street,<br/>
                Ekkattuthangal, Chennai – 600032.
              </p>

              <a
                href="https://maps.app.goo.gl/C86tZ5hbz5CGWsPf6"
                target="_blank"
                rel="noopener noreferrer"
                className="view-map"
              >
                View Map
              </a>
            </div>

            <div className="contact-block">
              <h3 className="title-with-icon">
                <img src="/assets/icons/Download_mail.png" alt="Enquiry Icon" className="icon"/>
                <span className="enquiry-text">For Enquiries</span>
              </h3>

              <p>Have questions about our services, partnership?</p>

              <p className="info-row">
                <img src="/assets/icons/email.png" alt="Email Icon" className="icon"/>
                <a href="mailto:info@inypeople.com" style={{textDecoration:'none', color:'inherit'}}>
                  info@inypeople.com
                </a>
              </p>

              <p className="info-row">
                <img src="/assets/icons/phone.png" alt="Phone Icon" className="icon"/>
                <a href="tel:+919787729398" style={{textDecoration:'none', color:'inherit'}}>
                  +91 9787729398
                </a>
              </p>
            </div>

            <div className="contact-block">
              <h3 className="title-with-icon">
                <img src="/assets/icons/job_seeker.png" alt="Career Icon" className="icon"/>
                <span className="career-text">For Careers</span>
              </h3>

              <p>Interested in building your career with us?</p>

              <p className="info-row">
                <img src="/assets/icons/email.png" alt="Email Icon" className="icon"/>
                <a href="mailto:careers@inypeople.com" style={{textDecoration:'none', color:'inherit'}}>
                  careers@inypeople.com
                </a>
              </p>
            </div>

          </div>

          {/* Right Image */}
          <div className="contact-info-right">
            <img
              src="/assets/icons/announced_1.png"
              alt="Contact Illustration"
              className="contact-info-image"
            />
          </div>

        </div>
      </section>

      <div style={{height: '48px'}}></div>

    </main>
  );
};

export default Contactus;